module.exports = __webpack_public_path__ + "static/img/Industry.e3603da8.png";